import useSWR from 'swr';
import { TypeSubscriberShopCollection } from '@/lib/api/productCatalog/types';
import { TypeSubscriptionRecord } from '@/lib/api/subscriptionManager/types';
import { usePathname } from 'next/navigation';

interface UseSubscriberShopProps {
  userUuid: string;
  authToken: string;
  locale: string;
  filterBy?: string[];
}

interface UseSubscriberShopReturn {
  collections: TypeSubscriberShopCollection[];
  subscriptions: TypeSubscriptionRecord[];
  isLoading: boolean;
  error: any;
}

export const useSubscriberShop = ({
  userUuid,
  authToken,
  locale,
  filterBy,
}: UseSubscriberShopProps): UseSubscriberShopReturn => {
  const pathName = usePathname();
  const fetcher = () =>
    fetch('/api/account-settings/subscriberShop', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userUuid,
        authToken,
        locale,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch data');
        }
        return res.json();
      })
      .then((data) => {
        if (filterBy) {
          data.collections = data.collections.filter(
            (collection: TypeSubscriberShopCollection) =>
              filterBy.includes(collection.anchor),
          );
        }
        return data;
      });

  const slugKey = pathName?.split('/').pop() || 'sub-collections';

  const { data, error } = useSWR<{
    collections: TypeSubscriberShopCollection[];
    subscriptions: TypeSubscriptionRecord[];
  }>(slugKey, fetcher);

  return {
    collections: data?.collections || [],
    subscriptions: data?.subscriptions || [],
    isLoading: !data && !error,
    error,
  };
};
